export const appRoutesWithoutTopNavBar = {
    displayToS: { key: 'displayToS', path: '/contracts/displayToS/[contractId]/[templateSubType]/[orderType]' },
}

export const appRoutes = {
    homepage: { key: '', path: '/' },
    contracts: { key: 'contracts', path: '/contracts' },
    pvcontracts: { key: 'contracts', path: '/contracts/pv' },
    hpContracts: { key: 'hpContracts', path: '/contracts/hp' },
    products: { key: 'products', path: '/products' },
    spvs: { key: 'spvs', path: '/spvs' },
    templates: { key: 'templates', path: '/contracts/templates' },
    subtypes: { key: 'subtypes', path: '/contracts/subtypes' },
    placeholders: { key: 'placeholdersV1', path: '/placeholders' },
    imagePlaceholders: { key: 'imagePlaceholders', path: '/placeholders/image' },
    imagePlaceholdersEdit: { key: 'imagePlaceholdersEdit', path: '/placeholders/image/edit' },
    handleContract: { key: 'handleContract', path: '/contracts/handleContract' },
    presentations: { key: 'presentations', path: '/presentations' },
    presentationGroups: { key: 'presentationGroups', path: '/presentations/groups' },
    presentationTemplates: { key: 'presentationTemplates', path: '/presentations/templates' },
    presentationSubtypes: { key: 'presentationSubtypes', path: '/presentations/subtypes' },
    createPresentationGroup: { key: 'createPresentationGroup', path: '/presentations/groups/create' },
    presentationGroupsEdit: { key: 'presentationGroupsEdit', path: '/presentations/groups/edit' },
    configurationPath: { key: 'placeholders', path: '/placeholders/configurations' },
    placeholderConfigPath: { key: 'placeholders', path: '/placeholders/configurations/placeholders' },
    conditionConfigPath: { key: 'conditionConfigs', path: '/placeholders/configurations/conditions' },
    assets: { key: 'assets', path: '/placeholders/assets' },
    ...appRoutesWithoutTopNavBar,
}
